import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IHttpBasicResponse, IHttpBasicResponseEcwid, IHttpBasicResponseImageEcwid, IHttpBasicResponseStore, JsonApiResponse } from '@boxx/core';
import {
  ICategoryApiModel,
  ICategoryImageUploadApiModel,
  ICreateOrderPayload,
  ICreateVariationPayload,
  IImageApiModel,
  IOrderApiModel,
  IProductApiModel,
  IProfileApiModel,
  IUpdateStatusOrderPayload,
  IUpsertCategoryPayload,
  IUpsertProductPayload,
  IVariationApiModel,
} from './IStore.api';
import { EcwidModel } from '../models/Ecwid.model';
import { EcwidImageModel } from '../models/EcwidImage.model';
import { IProductImages, IProductImageUpload } from '../models/Product.model';
import { IUpdateProfileStorePayload, StatesModelProps, StoreProfileModel } from '../models/Store.model';
import { IPixabayImages } from '@boxx/boxx-images/lib/contracts/IImages';

export interface IStoreRepository {
  // --------------------- CATEGORIES: -------------------------
  loadCategories(
    pagination?: string
  ): Observable<IHttpBasicResponseEcwid<ICategoryApiModel[]>>;
  loadCategoryById(
    id: number
  ): Observable<IHttpBasicResponse<ICategoryApiModel>>;
  getSingleCategory(
    id: number
  ): Observable<IHttpBasicResponseImageEcwid<ICategoryImageUploadApiModel>>;
  createCategory(
    payload: IUpsertCategoryPayload
  ): Observable<IHttpBasicResponse<ICategoryApiModel>>;
  // createCategory(
  //   payload: IUpsertCategoryPayload
  // ): Promise<any>;
  updateCategory(
    payload: IUpsertCategoryPayload
  ): Observable<IHttpBasicResponse<ICategoryApiModel>>;
  deleteCategory(id: number): Observable<IHttpBasicResponse<null>>;
  uploadImageCategory(
    id: number,
    file: string
  ): Observable<IHttpBasicResponse<EcwidImageModel>>;
  deleteImageCategory(id: number): Observable<IHttpBasicResponse<null>>;

  // --------------------- ORDERS: -------------------------
  loadOrders(): Observable<IHttpBasicResponseEcwid<IOrderApiModel[]>>;
  loadOrderById(id: string): Observable<IHttpBasicResponse<IOrderApiModel>>;
  updateOrder(
    payload: IUpdateStatusOrderPayload
  ): Observable<IHttpBasicResponse<IOrderApiModel>>;
  createOrder(
    payload: ICreateOrderPayload
  ): Observable<IHttpBasicResponse<IOrderApiModel>>;
  deleteOrder(id: string): Observable<IHttpBasicResponse<null>>;

  // --------------------- PRODUCTS: -------------------------
  loadProducts(): Observable<IHttpBasicResponseEcwid<IProductApiModel[]>>;
  loadProductById(id: number): Observable<IHttpBasicResponse<IProductApiModel>>;
  createProduct(
    payload: IUpsertProductPayload
  ): Observable<IHttpBasicResponse<IProductApiModel>>;
  updateProduct(
    payload: IUpsertProductPayload
  ): Observable<IHttpBasicResponse<IProductApiModel>>;
  deleteProduct(id: number): Observable<IHttpBasicResponse<null>>;
  getSingleProduct(
    id: number
  ): Observable<IHttpBasicResponseImageEcwid<IProductApiModel>>;
  uploadImageProduct(payload: IProductImageUpload): Observable<JsonApiResponse<any>>;
  deleteImageProduct(payload: any): Observable<IHttpBasicResponse<null>>;
  // ---------------- PRODUCT VARIATIONS: ---------------------
  loadProductsVariations(
    pagination?: string
  ): Observable<IHttpBasicResponse<IVariationApiModel[]>>;
  loadProductVariationByVariationId(
    id: number
  ): Observable<IHttpBasicResponse<IVariationApiModel>>;
  createProductVariation(
    payload: ICreateVariationPayload
  ): Observable<IHttpBasicResponse<IVariationApiModel>>;
  createProductVariation(
    payload: ICreateVariationPayload
  ): Observable<IHttpBasicResponse<IVariationApiModel>>;
  deleteProductVariation(id: number): Observable<IHttpBasicResponse<null>>;

  // --------------------- IMAGES: -------------------------
  loadSiteImages(
    pagination?: string
  ): Observable<IHttpBasicResponse<IImageApiModel[]>>;
  loadSiteImageById(id: number): Observable<IHttpBasicResponse<IImageApiModel>>;
  createSiteImage(
    payload: number
  ): Observable<IHttpBasicResponse<IImageApiModel>>;
  deleteSiteImage(id: number): Observable<IHttpBasicResponse<null>>;
  
  // --------------------- ECWID: -------------------------
  getLinkSSO(): Observable<IHttpBasicResponse<EcwidModel>>;
  openSSOHidden(url: string): Observable<IHttpBasicResponse<EcwidModel>>;
  getLinkValidation(): Observable<IHttpBasicResponse<EcwidModel>>;
  getToken(bId: number, businessId: number): Observable<IHttpBasicResponse<EcwidModel>>;
  getProfile(): Observable<IHttpBasicResponseStore<StoreProfileModel>>;
  searchImages(imageFilter: any): Observable<IHttpBasicResponse<IPixabayImages>>;
  updateProfile(
    payload: IUpdateProfileStorePayload
  ): Observable<IHttpBasicResponse<IProfileApiModel>>;
  uploadImageProfile(
    file: string
  ): Observable<IHttpBasicResponse<EcwidImageModel>>;
  deleteImageProfile(payload: any): Observable<IHttpBasicResponse<null>>;

   // --------------------- COUPONS: -------------------------
   loadCoupons(): Observable<IHttpBasicResponseEcwid<any[]>>;
   createCoupon(
     payload: any
   ): Observable<IHttpBasicResponse<any>>;
   updateCoupon(
     payload: any
   ): Observable<IHttpBasicResponse<any>>;
   deleteCoupon(id: number): Observable<IHttpBasicResponse<null>>;
   getSingleCoupon(
     id: number
   ): Observable<IHttpBasicResponseImageEcwid<any>>;
}

export const STORE_REPOSITORY = new InjectionToken<IStoreRepository>(
  'StoreRepository'
);
